import { useCallback, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import type { ReportTemplate, ReportTemplateDto } from "../../../../../../../api/types/svTypes.ts";
import { getApplyTemplateUrl } from "../../../../report-lists/reports/utilities/editReportUrl.ts";
import CompanyTemplatesDialog from "../../../../report-lists/templates/CompanyTemplatesDialog.tsx";
import ReportTemplatesButton from "../../../../report-lists/templates/ReportTemplatesButton.tsx";

interface Props {
  templates: ReportTemplateDto[];
  clientCode: string;
  disabled?: boolean;
}
export default function ReportTemplates({ templates, clientCode, disabled = false }: Props) {
  const [openTemplates, setOpenTemplates] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleQuickUse = useCallback(
    (template: ReportTemplate) => {
      setOpenTemplates(false);
      navigate(getApplyTemplateUrl(clientCode, id || "", template.reportId));
    },
    [navigate, clientCode, id]
  );

  const showBadge = useMemo(() => {
    return templates.some((t) => t.isNew);
  }, [templates]);

  const doOpenTemplates = useCallback(() => {
    setOpenTemplates(true);
  }, []);

  const doHideTemplates = useCallback(() => {
    setOpenTemplates(false);
  }, []);

  return (
    <>
      <ReportTemplatesButton onClick={doOpenTemplates} showBadge={showBadge} disabled={disabled} />
      {openTemplates && (
        <CompanyTemplatesDialog
          templates={templates}
          onClose={doHideTemplates}
          hideCreateBlankReport={true}
          onQuickUse={handleQuickUse}
        />
      )}
    </>
  );
}
